<div class="d-flex flex-column align-items-center justify-content-center min-vh-100">
    <img src="./assets/images/logo-drfeel-colori.png" alt="logo drfeel" />
    <h1 class="drfeel-color mt-5">Work in Progress</h1>
</div>